import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {getCouriers} from "./courier-api";
import {getCourierProfile} from "../data-tables-distributor/orders/courier-api";

export default function useCourierData(tenantId, id, page = 0, size = 20) {
    const {i18n} = useTranslation();
    const [result, setResult] = useState({loading: true, data: null, error: ""});
    const [version, setVersion] = useState(0);
    const language = i18n.language;
    const baseScope = `${tenantId}:${id || "list"}:${page}:${size}:${language}`;
    const scope = `${baseScope}:${version}`;

    useEffect(() => {
        const controller = new AbortController();
        // Keep an already verified profile mounted during refresh so its order filters and page are preserved.
        setResult(previous => ({scope, baseScope, loading: true,
            data: id && previous.baseScope === baseScope ? previous.data : null, error: ""}));
        const read = id ? getCourierProfile(id, language, controller.signal)
            : getCouriers(page, size, language, controller.signal);
        read.then(data => {
            if (controller.signal.aborted) return;
            // Never display a profile from an obsolete or incorrectly scoped response.
            const valid = id ? data.tenantId === tenantId : data.content.every(profile => profile.tenantId === tenantId);
            setResult({scope, baseScope, loading: false, data: valid ? data : null, error: valid ? "" : "CouriersLoadFailed"});
        }).catch(error => {
            if (!controller.signal.aborted) setResult({scope, baseScope, loading: false, data: null,
                error: error.response?.data?.message || "CouriersLoadFailed"});
        });
        return () => controller.abort();
    }, [tenantId, id, page, size, language, scope, baseScope]);

    const current = result.scope === scope ? result : {loading: true, data: null, error: ""};
    const retainedProfile = Boolean(id && result.baseScope === baseScope && result.data);
    return {...current, data: retainedProfile ? result.data : current.data,
        loading: current.loading && !retainedProfile, refreshing: current.loading && retainedProfile, version,
        refresh: () => setVersion(value => value + 1)};
}
